import React, { useState, useEffect } from "react";
import SearchInput from "../../../components/SearchInput/SearchInput";
import ButtonIcon from "../../../components/ButtonIcon/ButtonIcon";
import style from "../Style.module.scss";
import Download from "../../../assets/svg/icons/common/Download";
import Plus from "../../../assets/svg/icons/common/Plus";
import Listing from "./List/Listing";
import FilterDrawer from "./FilterDrawer/Index";
import { getPreapp } from "../../../../api";
import { toast, Toaster, ToastBar } from "react-hot-toast";
import useMerchantStore from "../../../stores/merchant";
import useCommonStore from "../../../stores/common";

function Merchants() {
  const setMerchantList = useMerchantStore((state) => state.setMerchantList);
  const merchantList = useMerchantStore((state) => state.merchantList);
  const setPageCount = useMerchantStore((state) => state.setPageCount);
  const showDetails = useCommonStore((state) => state.showDetails);
  const setFilterDrawerOpen = useCommonStore(
    (state) => state.setFilterDrawerOpen,
  );
  const merchantFilterSearchQuery = useMerchantStore(
    (state) => state.merchantFilterSearchQuery,
  );
  const setMerchantFilterSearchQuery = useMerchantStore(
    (state) => state.setMerchantFilterSearchQuery,
  );

  const [searchText, setSearchText] = useState("");
  const [filerApplied, setFilterApplied] = useState(false);

  const onChangeSearchInput = (e) => {
    setSearchText(e.target.value);
    setMerchantFilterSearchQuery({
      search: e.target.value,
      page: 1,
    });
  };

  const loadPreapps = () => {
    getPreapp(merchantFilterSearchQuery).then((res) => {
      let response = res.data;
      if (response.data.length > 0) {
        setMerchantList(response.data);
        setPageCount(response?.last_page);
      }
    });
  };

  useEffect(() => {
    loadPreapps();

    if (merchantFilterSearchQuery.search != "") {
      setFilterApplied(true);
    } else {
      setFilterApplied(false);
    }
  }, [merchantFilterSearchQuery]);

  return (
    <>
      <div className={style.page_heading}>
        <div className={style.title_contents}>
          <p>All Merchants</p>
        </div>
        <div className={style.right_side}>
          <SearchInput onChange={onChangeSearchInput} value={searchText} />
          {/* <ButtonIcon
            bgColor="#EDEDF4"
            onClick={() => setFilterDrawerOpen(true)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M14.4125 3.09564C14.3355 2.91784 14.208 2.76658 14.0458 2.66068C13.8835 2.55477 13.6937 2.49891 13.5 2.50002H2.49998C2.30644 2.5004 2.11717 2.55694 1.95512 2.66277C1.79308 2.76861 1.66523 2.91919 1.58709 3.09626C1.50894 3.27332 1.48386 3.46926 1.51488 3.6603C1.54591 3.85134 1.6317 4.02928 1.76186 4.17252L1.76686 4.17814L5.99998 8.69814V13.5C5.99994 13.681 6.04902 13.8586 6.14198 14.0139C6.23494 14.1692 6.36831 14.2963 6.52785 14.3818C6.6874 14.4672 6.86714 14.5078 7.04792 14.4991C7.2287 14.4904 7.40373 14.4329 7.55436 14.3325L9.55436 12.9988C9.69146 12.9074 9.80388 12.7837 9.88162 12.6384C9.95936 12.4932 10 12.331 9.99998 12.1663V8.69814L14.2337 4.17814L14.2387 4.17252C14.3703 4.02993 14.4569 3.85176 14.4878 3.66025C14.5187 3.46873 14.4925 3.27236 14.4125 3.09564ZM9.13623 8.16127C9.04974 8.25297 9.00107 8.37396 8.99998 8.50002V12.1663L6.99998 13.5V8.50002C7.00002 8.37305 6.95176 8.25083 6.86498 8.15814L2.49998 3.50002H13.5L9.13623 8.16127Z"
                fill="#3A383F"
              />
            </svg>
            {filerApplied && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                className={style.filter_active}
              >
                <path
                  d="M3.99992 6.83333C5.74882 6.83333 7.16658 5.41557 7.16658 3.66667C7.16658 1.91777 5.74882 0.5 3.99992 0.5C2.25102 0.5 0.833252 1.91777 0.833252 3.66667C0.833252 5.41557 2.25102 6.83333 3.99992 6.83333Z"
                  fill="#E03B24"
                  stroke="#EDEDF4"
                />
              </svg>
            )}
          </ButtonIcon> */}

          {/* {!showDetails && (
            <>
              <ButtonIcon
                bgColor="#EDEDF4"
                onClick={() => setFilterDrawerOpen(true)}
              >
                <Download />
                <span>Download</span>
              </ButtonIcon>
              <ButtonIcon
                bgColor="#4C70EF"
                textColor="#fff"
                onClick={() => setFilterDrawerOpen(true)}
              >
                <Plus />
                <span>Add Merchant</span>
              </ButtonIcon>
            </>
          )} */}
        </div>
      </div>

      <div className={style.card}>
        <Listing />
      </div>

      <FilterDrawer />

      {/* Toaster global component */}
      <Toaster
        position="top-right"
        containerStyle={
          {
            // height: "100vh",
            // width: "100vw",
          }
        }
        toastOptions={{
          style: {
            borderRadius: "8px",
            background: "rgba(40, 39, 45, 0.85)",
            color: "#fff",
            padding: "16px 24px",
          },
          duration: 5000,
        }}
      >
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                <button
                  className={style.toast_dismissal_button}
                  onClick={() => toast.dismiss(t.id)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M12.8535 12.1462C12.9 12.1927 12.9368 12.2478 12.962 12.3085C12.9871 12.3692 13.0001 12.4343 13.0001 12.5C13.0001 12.5657 12.9871 12.6307 12.962 12.6914C12.9368 12.7521 12.9 12.8073 12.8535 12.8537C12.8071 12.9002 12.7519 12.937 12.6912 12.9622C12.6305 12.9873 12.5655 13.0003 12.4998 13.0003C12.4341 13.0003 12.369 12.9873 12.3083 12.9622C12.2476 12.937 12.1925 12.9002 12.146 12.8537L7.99979 8.70685L3.85354 12.8537C3.75972 12.9475 3.63247 13.0003 3.49979 13.0003C3.36711 13.0003 3.23986 12.9475 3.14604 12.8537C3.05222 12.7599 2.99951 12.6327 2.99951 12.5C2.99951 12.3673 3.05222 12.24 3.14604 12.1462L7.29291 7.99997L3.14604 3.85372C3.05222 3.7599 2.99951 3.63265 2.99951 3.49997C2.99951 3.36729 3.05222 3.24004 3.14604 3.14622C3.23986 3.0524 3.36711 2.99969 3.49979 2.99969C3.63247 2.99969 3.75972 3.0524 3.85354 3.14622L7.99979 7.2931L12.146 3.14622C12.2399 3.0524 12.3671 2.99969 12.4998 2.99969C12.6325 2.99969 12.7597 3.0524 12.8535 3.14622C12.9474 3.24004 13.0001 3.36729 13.0001 3.49997C13.0001 3.63265 12.9474 3.7599 12.8535 3.85372L8.70666 7.99997L12.8535 12.1462Z"
                      fill="white"
                    />
                  </svg>
                </button>
              </>
            )}
          </ToastBar>
        )}
      </Toaster>
    </>
  );
}

export default Merchants;
